import "swiper/css";
import "swiper/css/pagination";

import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { Link } from "react-router-dom";

// Make sure you import Swiper’s CSS

// import "swiper/css/navigation"; // only if needed

const swiperOptions = {
	modules: [Autoplay],
	effect: "fade",
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		dynamicBullets: true,
	},
	// autoplay: { delay: 5000, disableOnInteraction: false },
	// loop: true
};

export default function Slider1() {
	return (
		<Swiper {...swiperOptions} className="tf-slider-widget swiper mySwiper">
			<SwiperSlide className="tf-banner swiper-slide">
				<div className="image-slider">
					{/* 
            The <picture> element attempts the <source> first based on media queries. 
            If it doesn't match, it falls back to the <img> tag. 
          */}
					<picture>
						{/* 
              This media query says: if the orientation is portrait, use the portrait image.
              If not, the <img> below is used by default. 
            */}
						<source
							media="(orientation: portrait)"
							srcSet="/images/image copy 4.png"
						/>
						<img
							src="/images/image copy 4.png"
							alt="TFD Squad Tour Group"
							className="slider-image"
						/>
					</picture>
					<div className="overlay" />
				</div>

				<div className="themeflat-container">
					<div className="slide-item">
						{/* 
              Semi-transparent container behind text.
              We shift it further down so it doesn't collide with the top of the image. 
            */}
						<div className="slide-content">
							<h1 className="main-quote">
								Pursuing globally comparable excellence on behalf of WA’s
								talented young footballers.
							</h1>

							<ul className="bullet-list">
								<li>
									At TFD we have been able to compete with Real Madrid, Arsenal,
									Sporting Lisbon, Juventus and many more European giants.
								</li>
								<li>
									Join our proven TFD program—perfect for footballers aged 3–23
									seeking professional training or additional sessions beyond
									their club routine.
								</li>
								<li>We offer player pathways to suit every journey.</li>
								<li>
									Connect with up to 4 sessions per week, along with national
									and international travel experiences, and so much more
									football.
								</li>
								<li>
									TFD is committed to providing dedicated coaching and
									professional pathways.
								</li>
								<li>
									We have the connections, knowledge, and experience to take
									players on their next steps towards professional
									opportunities.
								</li>
								<li>
									We have the enthusiasm to help players develop their love for
									the game and become the best version of themselves.
								</li>
							</ul>

							<div className="button" style={{ marginTop: "1rem" }}>
								<Link to="/contact" className="flat-button">
									Express Interest
								</Link>
							</div>
						</div>
					</div>
				</div>
			</SwiperSlide>

			{/* If you add more slides, do so here. */}
		</Swiper>
	);
}
